/* verqo — Buyer Landing TRIMMED preview (Feb 2026)
   Renders real BuyersPage with:
     - Built-in floating header suppressed (mega-menu header used instead)
     - Roadmap section hidden → moves to /company/how-it-works
   Everything else kept at full size (hero, categories, three paths, bento,
   full pricing, CTA, trust).
*/
import { PreviewNavHeader } from "../../../components/marketing/PreviewNavHeader";
import { PreviewFooter } from "../../../components/marketing/PreviewFooter";
import BuyersPage from "../BuyersPage";

export default function BuyerLandingTrimmed() {
  return (
    <div className="min-h-screen bg-white">
      <PreviewNavHeader modeOverride="buyer" />
      <div data-testid="buyer-landing-trimmed-body">
        <BuyersPage trimmedForPreview />
      </div>
      <PreviewFooter modeOverride="buyer" />
    </div>
  );
}
